import React from 'react';
import ConnectedAllRequests from '../containers/ConnectedAllRequests';

const AllRequests: React.FC = () => {
  return <ConnectedAllRequests />;
};

export default AllRequests;
